import React from "react";
import { Select, Form } from "antd";
import { StyledDropdown, StyledDropdownContainer, Label } from "./styles";
import { Rule } from "antd/lib/form";
import { SizeType } from "antd/es/config-provider/SizeContext";

const { Option } = Select;

type OptionType = {
  value: any;
  key: string | number;
  label?: string;
  disabled?: boolean;
};
interface DropdownProps {
  label: string;
  options: OptionType[];
  fontWeight: string;
  loading?: boolean;
  placeholder?: string;
  name?: string | string[]; // Added to uniquely identify the Form.Item
  rules?: Rule[]; // Validation rules for Form.Item
  onSelect?: (value: any, option: any) => void;
  value?: any;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({ label, options, fontWeight, name, placeholder = "", value, loading = false, rules = [], onSelect = () => { }, disabled = false, size = "large", allowClear = false }) => {
  return (
    <StyledDropdownContainer>
      <StyledDropdown>
        <Form.Item
          name={name}
          rules={rules} // Pass validation rules
          label={label ? <Label fontWeight={fontWeight}>{label}</Label> : null}
        >
          <Select
            size={size}
            showSearch
            loading={loading}
            placeholder={placeholder}
            value={value}
            style={{ width: "100%" }}
            onSelect={(value: any, option: any) => onSelect(value, option.value)}
            filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            optionFilterProp="children"
            disabled={disabled}
            allowClear={allowClear}
          >
            {options.map((option) => (
              <Option key={option.key} value={option.value} disabled={option?.disabled}>
                {option.label || option.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </StyledDropdown>
    </StyledDropdownContainer>
  );
};

export default Dropdown;
